// import { init } from "@sentry/browser";
// init({
//     dsn: "https://d8d4e86921824fcea1b2e56dc45107e9@sentry.io/5177931",
//     release: "1.1.14",
// });

require('./alpine')
